import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Route configuration for assembly listing page.
 * Redirects to the unregistered assemblies view by default.
 */
export const Route = createFileRoute('/_app/assemblies/')({
  beforeLoad: () => {
    throw redirect({
      to: '/assemblies/$registrationStatus',
      params: { registrationStatus: 'unregistered' },
    });
  },
});
